import { ReactComponent as Model3dIconError } from '../../assets/icons/model-3d-icon-error.svg';
import { ReactComponent as Model3dIconSuccess } from '../../assets/icons/model-3d-icon-success.svg';
import { ReactComponent as Model3dIconWarning } from '../../assets/icons/model-3d-icon-warning.svg';
import { ReactComponent as Model3dIconWhite } from '../../assets/icons/model-3d-icon-white.svg';
import { Model3d } from '../../models/models';

import { Fragment } from 'react/jsx-runtime';

const Model3dStatusIcon = ({ model3d }: { model3d: Model3d }) => {
    const getColorIcon = () => {
        let statusIcon: any = null;
        switch (model3d.status.key) {
            case 'active':
                statusIcon = <Model3dIconWhite />;
                break;
            case 'rejected':
                statusIcon = <Model3dIconError />;
                break;
            case 'approved':
                statusIcon = <Model3dIconSuccess />;
                break;
            case 'replaced':
                statusIcon = <Model3dIconWarning />;
                break;
            default:
                return null;
        }
        return statusIcon;
    };
    return <Fragment>{getColorIcon()}</Fragment>;
};

export default Model3dStatusIcon;
